view.scaling = new Point(.5,.5)
const gradient = (item,colors,offset) => {
    // console.log(item.data.extremes)
    let extremes = item.data.extremes.map(e => item.getPointAt(e*item.length));
    let stops = [];
    let stopSkip = offset ? offset : num(100)/100;
    stops.push(new GradientStop(colors[0],0));
    stops.push(new GradientStop(colors[1],stopSkip));
    stops.push(new GradientStop(colors[1],1-stopSkip));
    stops.push(new GradientStop(colors[0],1));
    return {
      gradient : {
        stops: stops
      },
      origin: extremes[0],
      destination: extremes[1]
    }
  }
  
  class Bud {
    constructor({budSize,colors,position}){
      let offset = new Point([budSize,budSize]) * -.5
      let base = new Path.Circle(position,budSize);
      base.fillColor = colors[0];
      // base.strokeColor = "black";
      // base.fillColor = prettyRaCo();
      this.bud = base;
      this.bud.bringToFront();
    }
  }
  
  class Pedal {
    constructor({curve=.5,width=.5}){
      let pedal = new Path();
      let scale = 50+num(50);
      let extremes = [[(scale-(curve*scale)),width*scale],[scale-(curve*scale),(width*-scale)]]
        .map(e => new Point(e));
        console.log(extremes)
        curve = width*curve;
      let maxSize = (new Point((100-(curve*100)),width*100) - new Point(100-(curve*100),(width*-100))).y
      // pedal.strokeColor = "black";
      // pedal.fillColor = prettyRaCo();
      pedal.add([0,0]);
      pedal.curveTo(extremes[0],[scale,0])
      pedal.curveTo(extremes[1],[0,0])
      this.pedal = pedal;
      this.pedal.data.extremes = extremes.map(e => this.pedal.getOffsetOf(e)/this.pedal.length);
      console.log(this.pedal.data.extremes)
      this.angle = (new Point(100,0) - new Point((scale-(curve*scale)),width*scale)).angle;
      this.angle = (new Point(100,0) - this.pedal.getPointAt(this.pedal.length*.2)).angle;
    }
    get(){
      return this.pedal;
    }
    set position(position){
      this.pedal.position = position;
    }
  
  }
  
  class Pedals {
    constructor({budSize,colors,position}){
      this.budSize = budSize
      this.pedal =  new Pedal({
        curve: .25+Math.random()*.5,
        width: .25+ Math.random()*.5
      });
      this.colors = colors;
      this.position = position;
      this.pedals = new Group();
    }
    radiate(count,layers=1){
      this.pedal.position = this.position-[this.budSize,0];
      let petalColorJump = 20;
      let layerColorJump = petalColorJump * count;
      let skip = 360/(Math.floor(360/this.pedal.angle))*2;
      let gradientStopOffset = num(100)/100;
      count = (360/Math.abs(skip));
      console.log({skip})
      let layerStutter = Math.random()*.75;
      let layerItems;
      let layerRotationStutter = 1+Math.random();
      for (var l = 1; l < layers+1; l++) {
        let skipPedal = true;//Math.random > .5;
        console.log("layer ",l)
        let firstItem;
        for (var i = -1; i < count-1; i++) {
          
          let copy = this.pedal.pedal.clone();
          copy.bounds.rightCenter = this.position;
          let rotation = l*(skip/layerRotationStutter)+i*skip;
          copy.rotate(rotation,this.position);
          copy.data.rotation = rotation;
          copy.scale(1+(layerStutter*l),this.position)
          copy.strokeColor = "black";//this.colors[0]
          copy.fillColor = gradient(copy,this.colors,gradientStopOffset);//colorWheel(l*layerColorJump+i*petalColorJump);//prettyRaCo();
          copy.set ({
            shadowColor: new Color(0, 0, 0),
            // Set the shadow blur radius to 12:
            shadowBlur: 10/l,
            // Offset the shadow by { x: 5, y: 5 }
            shadowOffset: new Point(0, 0)
          })
          // if(l === 1 && i === -1){
          //   copy.fillColor = "grey"
          //   firstItem = copy;
          // }
          // if(l === 1 && i === (count - 3)){
          //   copy.fillColor = "white"
          //   firstItem.fillColor = "red"
          //   // copy.bringToFront();
          //   console.log(layerItems)
          //   // layerItems[0] =
          //   copy = firstItem.subtract(copy);
          //   firstItem.sendToBack();
          // }
          // this.add(copy)
          // layerItems.push(copy)
        }
      }
      this.reverse();
    }
    add(child){
      this.pedals.children.push(child)
      // if(Math.random()>.5)
        // child.bringToFront();
    }
    get(){
      return this.pedals;
    }
    reverse(){
      this.pedals.children.reverse()
    }
  }
  
  class Stem {
    constructor({position,size,colors,width=4}){
      this.stem = new Path();
      this.stem.strokeColor = colors[num(2)];
      this.stem.strokeWidth = width;
      this.stem.add(position);
      this.stem.add(position+[0,size.width*10]);
      this.stem.sendToBack();
    }
    bend(points,amt){
      for (var i = 0; i < amt; i++) {
        let offset = (this.stem.length/amt)*i;
        let pt = this.stem.getPointAt(offset);
        let normal = this.stem.getNormalAt((this.stem.length/amt)*i);
        this.stem.insert(this.stem.segments.length-1,pt+normal*([num(50)-25,0]))
        this.stem.smooth();
      }
    }
  }
  
  class Flower {
    constructor(x=view.bounds.center.x,y=view.bounds.center.y,width=window.innerWidth/12,height=window.innerWidth/8){
      this.position = [x,y];
      this.width = width;
      this.height = height;
      this.ratio = num(20)/100;
      let colorOffset = num(1536)
      this.colors = [colorWheel(colorOffset),colorWheel(colorOffset+100+num(800))];
      this.colors.push(this.colors[0])
      console.log(this.colors);
      this.config = {
        position: new Point(x,y),
        budSize:this.width*this.ratio,
        colors: this.colors,
        size: new Size(width,height)
      }
      this.pedals = new Pedals(this.config);
      this.pedals.radiate(num(10)+4,1+num(4));
      this.stem = new Stem(this.config);
      this.stem.bend(10,5);
      this.bud = new Bud(this.config);
      this.bud.bud.bringToFront();
      // this.group = new Group({children: [this.stem.stem,this.pedals.pedals,this.bud.bud]})
    }
    generate(){
      this.bud.remove();
      this.bud = new Bud();
      this.pedals.remove();
      this.pedals = new Pedals(this.config);
    }
  }
  
  let flower = new Flower();
  console.log(flower)
  
  function onMouseDown(e){
    // project.activeLayer.remove();
    flower = new Flower(e.point.x,e.point.y);
  }
  
  function onMouseDrag(e){
    project.activeLayer.remove();
    // flower = new Flower(e.point.x,e.point.y);
    project.activeLayer.remove();
  new Flower(view.bounds.center.x,view.bounds.center.y);
  }
  tool.minDistance = 100;
  
  function onMouseMove(e){
    // project.activeLayer.remove();
    // new Flower(view.bounds.center.x,view.bounds.center.y);
    // new Flower(view.bounds.center.x-window.innerWidth/2,view.bounds.center.y-window.innerHeight/2);
  }
  